import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { StudioOfferingApiClient } from '../../api-clients';
const {
  Provider,
  context,
  ...client
} = StudioOfferingApiClient;
export const StudioOfferingApiExtension = createModuleExtension({
  extensionName: 'studioOfferingApiExtension',
  Provider,
  SDK: {
    studioOfferingApiClient: client,
    studioOfferingContext: context
  }
});
//# sourceMappingURL=studio-offering.extension.js.map